import { HttpService } from "./httpService"

export class PaymentService extends HttpService {
    static async buyProduct(values){
        return this.post("/orders", values)
    }
}